(() => {
  const root = () => window.Shopify?.routes?.root || '/';
  let extras, latest = 0, busy = false;
  const money = cents => window.theme?.Currency?.formatMoney(cents, window.theme.settings.moneyFormat) || new Intl.NumberFormat(document.documentElement.lang, { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
  async function refreshExtras() {
    extras = document.querySelector('[data-ao-cart-extras]');
    if (!extras) return;
    const sequence = ++latest;
    try {
      const response = await fetch(root() + 'cart.js', {headers: {'Accept': 'application/json'}});
      if (!response.ok) return;
      const cart = await response.json();
      if (sequence !== latest) return;
      extras.hidden = cart.item_count === 0;
      const shipping = extras.querySelector('[data-ao-shipping]');
      const threshold = Number(extras.dataset.threshold);
      const enabled = extras.dataset.shippingEnabled === 'true' && threshold > 0 && cart.currency === extras.dataset.currency;
      shipping.hidden = !enabled;
      if (enabled) {
        const remaining = Math.max(0, threshold - cart.total_price);
        const label = shipping.querySelector('[data-ao-shipping-text]');
        label.innerHTML = remaining ? label.dataset.remaining.replace('[amount]', money(remaining)) : label.dataset.complete;
        shipping.querySelector('[data-ao-shipping-progress]').style.width = Math.min(100, cart.total_price / threshold * 100) + '%';
      }
      const upsells = extras.querySelector('[data-ao-upsells]');
      if (!upsells || !cart.item_count) return;
      const content = upsells.querySelector('[data-ao-upsell-content]');
      let html = '';
      try {
        const recResponse = await fetch(root() + 'recommendations/products?section_id=ao-cart-suggestions&product_id=' + cart.items[0].product_id + '&intent=complementary&limit=6');
        if (recResponse.ok) html = await recResponse.text();
      } catch (_) {}
      let doc = new DOMParser().parseFromString(html, 'text/html');
      const filterSuggestions = document => {
        const source = document.querySelector('[data-ao-suggestions]');
        if (!source) return null;
        const seen = new Set(cart.items.map(item => String(item.product_id)));
        for (const row of source.querySelectorAll('[data-product-id]')) {
          if (seen.has(row.dataset.productId)) row.remove();
          else seen.add(row.dataset.productId);
        }
        for (const row of [...source.querySelectorAll('[data-product-id]')].slice(2)) row.remove();
        return source;
      };
      let source = filterSuggestions(doc);
      if (!source?.querySelector('[data-product-id]')) {
        const fallback = await fetch(root() + '?section_id=ao-cart-suggestions');
        if (!fallback.ok) return;
        source = filterSuggestions(new DOMParser().parseFromString(await fallback.text(), 'text/html'));
      }
      if (sequence !== latest || busy) return;
      content.replaceChildren();
      if (source) content.append(source);
      upsells.hidden = !content.querySelector('[data-product-id]');
    } catch (_) {}
  }
  async function addUpsell(button) {
    if (busy || button.disabled) return;
    busy = true; ++latest;
    const extras = button.closest('[data-ao-cart-extras]');
    const error = extras.querySelector('[data-ao-cart-error]');
    error.textContent = '';
    const buttons = [...extras.querySelectorAll('[data-ao-upsell-add]')];
    buttons.forEach(item => {item.disabled = true;});
    button.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(root() + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(button.dataset.aoUpsellAdd),quantity:1}]})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || error.dataset.generic);
      document.dispatchEvent(new CustomEvent('cart:build'));
      const row = button.closest('[data-product-id]');
      if (row) row.remove();
    } catch (failure) {error.textContent = failure.message || error.dataset.generic;}
    finally {busy = false;button.removeAttribute('aria-busy');buttons.forEach(item => {item.disabled = false;});refreshExtras();}
  }
  function syncPlans(form) {
    const wrapper = form.querySelector('[data-ao-plans]');
    if (!wrapper) return;
    const variants = JSON.parse(wrapper.querySelector('[data-ao-plan-variants]').textContent);
    const variant = variants.find(item => String(item.id) === form.querySelector('[name="id"]')?.value);
    const select = wrapper.querySelector('[name="selling_plan"]');
    if (!variant) return;
    const validIds = new Set(variant.plans.map(plan => String(plan.id)));
    for (const option of select.options) {
      if (option.value) option.disabled = !validIds.has(option.value);
    }
    if (select.selectedOptions[0]?.disabled) select.value = '';
    if (!select.value && wrapper.dataset.required === 'true') select.value = [...select.options].find(option => !option.disabled && option.value)?.value || '';
    const allocation = variant.plans.find(plan => String(plan.id) === select.value);
    const price = form.closest('[data-section-id]')?.querySelector('[data-product-price]');
    if (price) price.innerHTML = money(allocation ? allocation.price : variant.price);
    const button = form.querySelector('[data-add-to-cart]');
    if (button) button.disabled = !variant.available || (wrapper.dataset.required === 'true' && !allocation);
    const stickyPrice = document.querySelector('[data-ao-sticky-price]');
    if (stickyPrice && price) stickyPrice.textContent = price.textContent;
  }
  function initPlans() {
    for (const wrapper of document.querySelectorAll('[data-ao-plans]')) {
      if (wrapper.dataset.initialized) continue;
      wrapper.dataset.initialized = 'true';
      const form = wrapper.closest('form');
      wrapper.querySelector('select').addEventListener('change', () => syncPlans(form));
      syncPlans(form);
    }
  }
  document.addEventListener('variant:change', () => queueMicrotask(() => {
    for (const wrapper of document.querySelectorAll('[data-ao-plans]')) syncPlans(wrapper.closest('form'));
  }));
  function initSticky() {
    const sticky = document.querySelector('[data-ao-sticky]');
    if (!sticky || sticky.dataset.initialized) return;
    const main = document.querySelector('.product-single__meta [data-add-to-cart]');
    if (!main) return;
    sticky.dataset.initialized = 'true';
    const button = sticky.querySelector('button');
    const sync = () => {
      button.disabled = main.disabled;
      button.textContent = main.querySelector('[data-add-to-cart-text]')?.textContent.trim() || main.textContent.trim();
      const price = document.querySelector('.product-single__meta [data-product-price]');
      if (price) sticky.querySelector('[data-ao-sticky-price]').textContent = price.textContent;
    };
    button.addEventListener('click', () => {
      const form = main.closest('form');
      if (form?.reportValidity()) main.click();
    });
    new MutationObserver(sync).observe(main, {subtree:true,childList:true,attributes:true});
    const observer = new IntersectionObserver(entries => {sticky.hidden = entries[0].isIntersecting;}, {threshold:0});
    observer.observe(main);
    document.addEventListener('variant:change',sync);
    document.addEventListener('variantChange',sync);
    sync();
  }
  function init() {
    const drawer = document.getElementById('CartDrawer');
    if (drawer) {drawer.setAttribute('role','dialog');drawer.setAttribute('aria-modal','true');drawer.setAttribute('aria-label',drawer.querySelector('.drawer__title')?.textContent.trim() || 'Cart');}
    initPlans(); initSticky(); refreshExtras();
  }
  document.addEventListener('click',event => {const button = event.target.closest('[data-ao-upsell-add]');if (button) addUpsell(button);});
  ['drawerOpen.CartDrawer','cart:updated','ajaxProduct:added'].forEach(name => document.addEventListener(name,refreshExtras));
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('quickview:loaded',init);
  new MutationObserver(initPlans).observe(document.documentElement,{childList:true,subtree:true});
  document.addEventListener('DOMContentLoaded',init);
  if (document.readyState !== 'loading') init();
})();
